import { FECH_USER_DASHBOARD_COUNT } from '../../../../constants/ApplicationUrl';
import api from "../../../../dependencies/utils/Api"



export const getCountData = async () => {
    try {
        const response = await api.GET(FECH_USER_DASHBOARD_COUNT);
        return response.data;
    } catch (error) {
        throw error;
    }
};